import React, { useState } from "react";
import axios from "axios";
import Swal from "sweetalert2";
import { useHistory } from "react-router-dom";

function AddAppUser() {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const navigate = useHistory();

  const getToken = () => {
    try {
      const raw = localStorage.getItem("state");
      if (raw) return JSON.parse(raw).auth?.token;
    } catch (e) {}
    return null;
  };

  const submit = (e) => {
    e.preventDefault();
    setLoading(true);
    const token = getToken();
    axios.post(`${process.env.REACT_APP_API_URL}/AppUser/AdminCreateUser`,
      { Email: email, Password: password },
      { headers: { "Content-Type": "application/json", ...(token && { Authorization: `Bearer ${token}` }) } }
    ).then(() => {
      Swal.fire({ title: "Success", text: "User created.", icon: "success", confirmButtonText: "Ok" })
        .then(() => navigate.push("/AppUserList"));
    }).catch(err => {
      Swal.fire({ title: "Error", text: err.response?.data || "Could not create user.", icon: "error", confirmButtonText: "Ok" });
    }).finally(() => setLoading(false));
  };

  return (
    <div className="page-content-wrapper">
      <div className="page-content">
        <div className="page-bar">
          <div className="page-title-breadcrumb">
            <div className="pull-left"><div className="page-title">Add App User</div></div>
            <div className="pull-right">
              <button className="btn" style={{ backgroundColor: "#1e2b38", color: "#FFF" }}
                onClick={() => navigate.push("/AppUserList")}>
                <i className="fa fa-arrow-left" />
              </button>
            </div>
          </div>
        </div>

        <div className="row">
          <div className="col-md-6">
            <div className="card card-box">
              <div className="card-head"><header>New User</header></div>
              <div className="card-body">
                <form onSubmit={submit}>
                  <div className="form-group mb-3">
                    <label className="control-label">Email</label>
                    <input type="email" className="form-control" value={email}
                      onChange={e => setEmail(e.target.value)} required />
                  </div>
                  <div className="form-group mb-3">
                    <label className="control-label">Password</label>
                    <input type="password" className="form-control" value={password}
                      onChange={e => setPassword(e.target.value)} required minLength={6} />
                  </div>
                  <button type="submit" className="btn btn-primary" disabled={loading}>
                    {loading ? "Creating..." : "Create User"}
                  </button>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default AddAppUser;